import styles from "./StatusChip.module.css";

/**
 * 상태 어휘. `job.*` 은 c6 status 도메인 그룹 `job` 의 키를 그대로 쓴다 — 한 상태 대상의
 * 어휘는 한 도메인 그룹 안에서 완결한다(RFC-status-token-layering §Layer 2, 규칙 §14).
 * `muted` 는 도메인이 없는 generic 신호(숨김 등)라 코어 키를 직접 쓴다.
 */
export type StatusTone = "job.pending" | "job.running" | "job.succeeded" | "job.failed" | "muted";

const TONE_CLASS: Record<StatusTone, string> = {
  "job.pending": styles.tonePending,
  "job.running": styles.toneRunning,
  "job.succeeded": styles.toneSucceeded,
  "job.failed": styles.toneFailed,
  muted: styles.toneMuted,
};

type StatusChipProps = {
  tone: StatusTone;
  children: string;
  className?: string;
};

/**
 * 상태 표시 칩(dot + 라벨).
 *
 * 라벨을 항상 함께 그린다 — 색만으로 상태를 말하면 색각 이상과 흑백 출력에서 뜻이 사라진다.
 */
export function StatusChip({ children, className, tone }: StatusChipProps) {
  return (
    <span className={[styles.chip, TONE_CLASS[tone], className ?? ""].filter(Boolean).join(" ")}>
      <span aria-hidden="true" className={styles.dot} />
      {children}
    </span>
  );
}
